import { Table } from '@quero-delivery/quero-components-web';
import { format } from '@querodelivery/qd-date-helper';
import classNames from 'classnames';
import type { Extract } from '@/_features/places/types';
import { centsToMoneyLabel } from '@/Utils/FnUtils';
import styles from './extract-row-modal.module.scss';

function ExtractRowModal({ extract }: { extract: Extract }) {
  const {
    custom_fields,
    created_at,
    cents,
    balance,
    descricao,
    tipo,
    key: transactionId,
  } = extract;

  const isPlacePage = location.pathname.includes('estabelecimentos');

  const descriptionField = custom_fields.filter(
    item => item.key === 'descritivo',
  );

  return (
    <Table.Row>
      <Table.Cell>
        <span className={styles.spanTable}>
          {format(new Date(created_at), 'dd/MM/yyyy HH:mm')}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span
          className={classNames(
            cents > 0 ? styles.credit : styles.debit,
            styles.spanTable,
          )}
        >
          {centsToMoneyLabel(cents)}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className={styles.spanTable}>{centsToMoneyLabel(balance)}</span>
      </Table.Cell>
      <Table.Cell>
        <span
          className={classNames(
            cents > 0 ? styles.credit : styles.debit,
            styles.spanTableCapitalized,
          )}
        >
          <p>{tipo}</p>
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className={styles.spanTableCapitalized}>
          <p>{descricao}</p>
        </span>
      </Table.Cell>
      {isPlacePage && (
        <Table.Cell>
          <span className={styles.spanTable}>{transactionId}</span>
        </Table.Cell>
      )}
      <Table.Cell>
        <span className={styles.spanTable}>{descriptionField[0]?.value}</span>
      </Table.Cell>
    </Table.Row>
  );
}
export { ExtractRowModal };
